import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconTrending6"><Path d="M15.75 17.25H21.25V11.75M20.7361 16.725L15.0007 10.9978C13.8955 9.89424 12.1051 9.89488 11.0007 10.9993C9.89575 12.1042 8.10425 12.1042 6.99928 10.9993L2.75 6.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconTrending6;
